<template>
  <CModal :title="$t('timeRegistrationModal.title')" icon="clock-timestamp" @close="close">
    <template #body>
      <CTimeRegistrationProgressBar v-if="isPresent(context.timeRegistrationContainer?.allowedMinutes)" :timeRegistrationContainer="present(context.timeRegistrationContainer)"/>

      <CTimeRegistrationJobsCard v-if="!hasContinuousTimeRegistration" :context/>

      <CTimeRegistrationCard v-for="registration in registrations" :key="registration.id"
                             :registration="registration" :context/>
    </template>

    <template #footer>
      <CButton @click="close" class="c-modal-cancel">{{ $t('general.close') }}</CButton>
    </template>
  </CModal>
</template>

<script setup lang="ts">
  import { orderBy } from 'lodash';
  import { computed } from 'vue';
  import CModal from '@/general/components/CModal.vue';
  import AuthService from '@/general/services/AuthService';
  import CButton from '@/shared/components/buttons/CButton.vue';
  import { isPresent, present } from '@/shared/utils/typescript';
  import CTimeRegistrationCard from '../components/timeRegistration/CTimeRegistrationCard.vue';
  import CTimeRegistrationJobsCard from '../components/timeRegistration/CTimeRegistrationJobsCard.vue';
  import CTimeRegistrationProgressBar from '../components/timeRegistration/CTimeRegistrationProgressBar.vue';
  import JobContext from '../models/JobContext';

  const emit = defineEmits<{ (e: 'close'): void }>();

  const props = defineProps<{
    context: JobContext;
  }>();

  const hasContinuousTimeRegistration = computed(() => AuthService.getCurrentUser().getOutlet(props.context.dossier.outletId).hasContinuousTimeRegistration);

  const registrations = computed(() => orderBy(props.context.timeRegistrationContainer?.registrations, 'startedOn'));

  function close() {
    emit('close');
  }
</script>